/** 화주 찾기 모달 결과 — 회원가입 2.0 `/api/v1/auth/shippers` 응답을 모달 형태로 옮긴 것(1.0 응답 필드는 LOGISPRD-15411 에서 제거) */
export interface ShipperSearchItem {
  shipper_code: string
  shipper_name: string
}

/** 부서 찾기 모달 결과 — 회원가입 2.0 `/api/v1/auth/departments` 응답을 모달 형태로 옮긴 것 */
export interface DepartmentSearchItem {
  DEPT_NM: string
}

/** get-shippers 를 화면코드와 함께 부르는 화면 — 감사 로그 대상(LOGISPRD-16007) */
export type ShipperMenuCode = 'MA14'

export interface GetShipperListV2Req {
  shipperNames: string[]
  logisticsServiceTypes: string[]
}

export interface GetShipperNamesReq {
  logisticsServiceTypes: string[]
  size?: number
}

export type PlatformType = 'MANAGED' | 'ETC' | 'OWN_MALL'

// TODO: 임시 화주사 조회 타입
export interface ShipperItem {
  logisticsServiceType: string
  companyName: string
  shipperCode: string
  shipperName: string
  mfsTermsAgreedAt: string // "2023-10-01T00:00:00.000Z"
  ownerName: string
  businessRegistrationNumber: string

  salesPlatforms: {
    masterCompanyId?: number
    type: PlatformType
    name: string
    companyId?: string
    usable?: boolean
    isBoutique?: boolean
  }[]
  businessType: string
  businessMajor: string
  address: string
  zipCode: string
  phoneNumber: string
}

export interface CreateMWPShipperReq {
  companyName: string
  ownerName: string
  shipperName: string
  businessRegistrationNumber: string
  salesPlatform: [
    {
      type: string
      name: string
      companyId?: string
      usable?: boolean
      isBoutique?: boolean
    },
  ]
  businessType: string
  businessMajor: string
  address: string
  zipCode: string
  phoneNumber: string
}

export interface CreateMLTShipperReq {
  companyName: string
  ownerName: string
  shipperName: string
  businessRegistrationNumber: string
  salesPlatforms: [
    {
      type: string
      name: string
      companyId: string
      usable?: boolean
      isBoutique?: boolean
    },
  ]
  businessType?: string
  businessMajor?: string
  address?: string
  zipCode?: string
  phoneNumber?: string
}

export interface CreateMCDShipperReq {
  companyName: string
  ownerName: string
  shipperName: string
  businessRegistrationNumber: string
  businessType: string
  businessMajor: string
  address: string
  zipCode: string
  phoneNumber: string
}

export interface UpdateMFSShipperReq {
  shipperCode: string
  ownerName?: string
  businessRegistrationNumber: string
  businessType?: string
  businessMajor?: string
  address?: string
  zipCode?: string
  phoneNumber?: string
}

export interface UpdateMWPShipperReq {
  shipperCode: string
  shipperName?: string
  companyName?: string
  businessRegistrationNumber: string
  ownerName?: string
  businessType?: string
  businessMajor?: string
  address?: string
  zipCode?: string
  phoneNumber?: string
}

export interface UpdateMCDShipperReq {
  shipperCode: string
  shipperName?: string
  companyName: string
  businessRegistrationNumber: string
  ownerName?: string
  businessType?: string
  businessMajor?: string
  address?: string
  zipCode?: string
  phoneNumber?: string
}
export interface UpdateMLTShipperReq {
  shipperCode: string
  shipperName?: string
  companyName?: string
  businessRegistrationNumber: string
  ownerName?: string
  businessType?: string
  businessMajor?: string
  address?: string
  zipCode?: string
  phoneNumber?: string
}

export type HasShipperCodeAsPathParams<T> = T & {
  shipperCode: string
}

export interface CreateSalesPlatformReq {
  type: string
  name: string
  companyId?: string
  usable: true
}
export interface DeleteSalesPlatformReq {
  type: string
  name: string
  companyId?: string
}
export interface UpdateSalesPlatformReq {
  masterCompanyId: number
  newSalesPlatformName?: string
  newSalesPlatformType?: string
  newCompanyId?: string
  usable?: boolean
}

export type ShipperType = 'M1P' | 'MFS' | 'MWP' | 'MLT' | 'MCD' | 'MTP'

// 화주 드롭다운 응답 행 — 1.0 SPR_NM_SearchForm 트리플 (editShipperCode 는 shipperCode 복제값)
export interface ShipperDropdownItem {
  shipperCode: string
  businessName: string
  editShipperCode: string
}

/**
 * 화주사 등록·수정의 업체아이디 허용 문자 확장 게이트 (LOGISPRD-11899).
 *
 * ON  — 영문·숫자에 더해 ~ - . [ ] { } : ! @ # $ % ^ & * ( ) + = _ 를 받는다
 * OFF — 영문·숫자·언더스코어까지만 받는 종전 규칙 (LOGISPRD-10474)
 *
 * 조회 실패·미등록 시 false 로 떨어져 종전 규칙이 살아남는다.
 */
export const SHIPPER_COMPANY_ID_SPECIAL_CHARS_FLAG = 'feature.shipperCompanyIdSpecialChars' as const
